// extracted by mini-css-extract-plugin
export default {"main":"styles_main__eKsEZ","box":"styles_box__R7SGP"};